<template>
	<Container>
		<Title>
			{{ $t('contratacion') }}
		</Title>
		<div>
			<div class="w-full flex">
				<ButtonBlack>
					<router-link :to="'/admin/listado/configuracion'" class="text-white no-underline">
						<div class="flex items-center">
							<span>{{ $t('configuracion') }}</span>
						</div>
					</router-link>
				</ButtonBlack>
				<div class="input-group pl-5 flex items-center">
					<input v-model="search" @keyup="onChangeSearch()" type="text" class="sm:w-64 form-control p-2 border-b border-gray-400 w-32 focus:border-blue-500 focus:outline-none" placeholder="Buscar" />
					<span>
						<img src="@/assets/img/buscar.svg" />
					</span>
				</div>

				<div class="input-group pl-5 flex items-center">
					<select v-model="status" @change="onChangeSearch()" class="sm:w-64 form-control p-2 border-b border-gray-400 w-32 focus:border-blue-500 focus:outline-none">
						<option :value="null">Todos los estados</option>
						<option value="PEN">Pendiente</option>
						<option value="PRO">En proceso</option>
						<option value="COM">Completada</option>
						<option value="CAN">Cancelado</option>
						<option value="CAD">Caducado</option>
						<option value="YES">Respuesta afirmativa</option>
						<option value="DOC">Documentación recibida</option>
					</select>

					<select v-model="contractCategory" @change="onChangeSearch()" class="sm:w-64 form-control p-2 border-b border-gray-400 w-32 focus:border-blue-500 focus:outline-none">
						<option :value="null">Todas las categorias</option>
						<option :value="4">Alta nueva comercial</option>
						<option :value="5">Cambio de categoría comercial</option>
						<option :value="6">Reactivación comercial</option>
						<option :value="7">Actualización contrato</option>
						<option :value="8">Beneficios</option>
					</select>

					<span>
						<img src="@/assets/img/buscar.svg" />
					</span>
				</div>

				<ButtonBlack>
					<a @click="openModal()" class="text-white no-underline">
						<div class="flex items-center">
							<span>{{ $t('Filtrar') }}</span>
						</div>
					</a>
				</ButtonBlack>
				<ButtonBlack>
					<router-link :to="'/' + section" class="text-white no-underline">
						<div class="flex items-center">
							<img src="@/assets/img/nuevo-mas.svg" alt="Nuevo" />
							<span>{{ $t('new') }}</span>
						</div>
					</router-link>
				</ButtonBlack>
				<ButtonBlack>
					<a :disabled="downloading" @click="download()" class="text-white no-underline">
						<div class="flex items-center">
							<span v-if="!downloading">{{ $t('export_excel') }}</span>
							<span v-if="downloading">...</span>
						</div>
					</a>
				</ButtonBlack>
			</div>
			<div>
				<ListTable :itemsTitles="itemsTitles" :items="contracts" :section="section" :isAdmin="false" :itemsTable="itemsTable" />
			</div>
		</div>
		<!-- Modal -->
		<transition name="modal">
			<div v-if="showModal" class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
				<div class="bg-white p-8 rounded shadow-lg w-full sm:w-2/3 md:w-1/2">
					<h3 class="text-xl font-semibold mb-6 text-center">Búsqueda avanzada</h3>

					<!-- Contenedor con flexbox -->
					<div class="flex flex-wrap -mx-3">
						<!-- Filtro por Fecha de Creación -->
						<div class="w-full md:w-1/2 px-3 mb-4">
							<label for="from" class="block text-sm font-medium text-gray-700">Desde (Creación)</label>
							<input v-model="from" id="from" :min="this.$moment().subtract(1, 'year').format('YYYY-MM-DD')" :max="this.$moment().format('YYYY-MM-DD')" type="date" class="block w-full form-control p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" />
						</div>

						<div class="w-full md:w-1/2 px-3 mb-4">
							<label for="to" class="block text-sm font-medium text-gray-700">Hasta (Creación)</label>
							<input v-model="to" id="to" :min="this.$moment(from).format('YYYY-MM-DD')" :max="this.$moment().format('YYYY-MM-DD')" type="date" class="block w-full form-control p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" />
						</div>

						<!-- Filtro por Fecha de Actualización -->
						<div class="w-full md:w-1/2 px-3 mb-4">
							<label for="fromUpdate" class="block text-sm font-medium text-gray-700">Desde (Actualización)</label>
							<input v-model="fromUpdate" id="fromUpdate" :min="this.$moment().subtract(1, 'year').format('YYYY-MM-DD')" :max="this.$moment().format('YYYY-MM-DD 00:00')" type="datetime-local" class="block w-full form-control p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" />
						</div>

						<div class="w-full md:w-1/2 px-3 mb-4">
							<label for="toUpdate" class="block text-sm font-medium text-gray-700">Hasta (Actualización)</label>
							<input v-model="toUpdate" id="toUpdate" :min="this.$moment(fromUpdate).format('YYYY-MM-DD 23:59')" :max="this.$moment().format('YYYY-MM-DD')" type="datetime-local" class="block w-full form-control p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" />
						</div>

						<div class="w-full md:w-1/2 px-3 mb-4">
							<label for="bulkSent" class="block text-sm font-medium text-gray-700">Envío</label>
							<select v-model="bulkSent" @change="onChangeSearch()" class="sm:w-64 form-control p-2 border-b border-gray-400 w-32 focus:border-blue-500 focus:outline-none">
								<option :value="null" selected>Todos los tipos</option>
								<option value="false">Individual</option>
								<option value="true">Masivo</option>
							</select>
						</div>
					</div>

					<!-- Botones de acción -->
					<div class="mt-6 flex justify-end space-x-4">
						<ButtonBlack>
							<span @click="showModal = false">Cerrar</span>
						</ButtonBlack>
					</div>
				</div>
			</div>
		</transition>
	</Container>
</template>

<script>
import ListTable from '@/components/ListTable';
import gql from 'graphql-tag';

export default {
	apollo: {
		contracts: {
			// Query dinámica usando la cláusula where generada en variables()
			query() {
				const filters = [] // Array de filtros
				const variables = [] // Array de variables que se van a usar en la declaración de la query

				// Filtro por fechas de contrato si $from y $to tienen valor
				if (this.from) {
					filters.push(`{ contract_date: { _gte: $from } }`)
					variables.push('$from: date')
				}
				if (this.to) {
					filters.push(`{ contract_date: { _lte: $to } }`)
					variables.push('$to: date')
				}
				if (this.fromUpdate && this.toUpdate) {
					filters.push(`{ status_update: { _gte: $fromUpdate, _lte: $toUpdate } }`)
					variables.push('$fromUpdate: timestamptz')
					variables.push('$toUpdate: timestamptz')
				} else if (this.fromUpdate) {
					filters.push(`{ status_update: { _gte: $fromUpdate } }`)
					variables.push('$fromUpdate: timestamptz')
				} else if (this.toUpdate) {
					filters.push(`{ status_update: { _lte: $toUpdate } }`)
					variables.push('$toUpdate: timestamptz')
				}
				if (this.bulkSent) {
					filters.push(`{ bulk_sent: { _eq: $bulkSent } }`)
					variables.push('$bulkSent: Boolean')
				}
				if (this.status) {
					filters.push(`{ status: { _eq: $status } }`)
					variables.push('$status: String')
				}
				if (this.contractCategory) {
					filters.push(`{ contract_category: { _eq: $contractCategory } }`)
					variables.push('$contractCategory: bigint')
				}
				if (this.search) {
					filters.push(`{
						_or: [
							{ document: { _ilike: $search } },
							{ name: { _ilike: $search } },
							{ phone: { _ilike: $search } }
						]
					}`)
					variables.push('$search: String')
				}

				// Unimos los filtros con una coma
				const whereClause = `_and: [${filters.join(', ')}]`

				// Unimos las variables para la declaración de la query
				const variableClause = variables.length > 0 ? `(${variables.join(', ')})` : ''

				// Devolver la consulta GraphQL con variables dinámicamente construidas
				return gql`
		query ${variableClause} {
			contracts(order_by: { id: desc }, where: { ${whereClause} }) {
				id
				document
				name
				phone
				responsable
				delegation
				contract_date
				status
				status_label
				status_update
				bulk_sent
				active
			}
		}
	`
			},

			variables() {
				// Construimos las variables, asegurando que todas se pasen, aunque sean null
				return {
					search: this.search ? `%${this.search}%` : undefined,
					from: this.from ? this.from : null,
					to: this.to ? this.to : null,
					fromUpdate: this.fromUpdate ? this.$moment(this.fromUpdate).toISOString() : undefined,
					toUpdate: this.toUpdate ? this.$moment(this.toUpdate).toISOString() : undefined,
					status: this.status ? this.status : undefined,
					contractCategory: this.contractCategory ? this.contractCategory : undefined,
					bulkSent: this.bulkSent ? this.bulkSent : undefined,
				}
			},

			update(data) {
				return data.contracts.map(item => ({
					id: item.id,
					document: item.document,
					name: item.name,
					phone: item.phone,
					responsable: item.responsable,
					delegation: item.delegation,
					status: this.$t(item.status),
					status_label: item.status_label,
					bulk_sent: item.bulk_sent === true ? 'Masivo' : item.bulk_sent === false ? 'Individual' : '',
					contract_date: this.$moment(item.contract_date).format('DD-MM-YYYY'),
					status_update: item.status_update ? this.$moment(item.status_update).format('DD-MM-YYYY H:mm:ss') : '-',
					edit: true,
					active: item.active,
				}))
			},
		},
	},
	data() {
		return {
			showModal: false,
			section: 'admin/listado/contrato',
			itemsTable: 'contracts',
			itemsTitles: ['Id', 'CIF/NIF', 'Nombre', 'Telefono', 'Responsable', 'Delegation', 'status', 'BTP', 'Envío', 'Creación', 'Cambio estado'],
			search: '',
			from: this.$moment().subtract(1, 'month').format('YYYY-MM-DD'),
			to: this.$moment().format('YYYY-MM-DD'),
			fromUpdate: null,
			toUpdate: null,
			downloading: false,
			status: null,
			contractCategory: null,
			bulkSent: null,
		}
	},
	components: {
		ListTable,
	},
	methods: {
		openModal() {
			this.showModal = true
		},
		onChangeSearch() {
			// Pasamos las variables con valores o null
			this.$apollo.queries.contracts.refetch({
				search: this.search ? `%${this.search}%` : undefined,
				from: this.from ? this.from : undefined,
				to: this.to ? this.to : undefined,
				fromUpdate: this.fromUpdate ? this.$moment(this.fromUpdate).toISOString() : undefined,
				toUpdate: this.toUpdate ? this.$moment(this.toUpdate).toISOString() : undefined,
				status: this.status ? this.status : undefined,
				contractCategory: this.contractCategory ? this.contractCategory : undefined,
				bulkSent: this.bulkSent ? this.bulkSent : undefined,
			})
		},
		download() {
			if (!this.downloading) {
				this.downloading = true
				const params = new URLSearchParams({
					from: this.from,
					to: this.to,
					...(this.fromUpdate && { fromUpdate: this.$moment(this.fromUpdate).toISOString() }),
					...(this.toUpdate && { toUpdate: this.$moment(this.toUpdate).toISOString() }),
					...(this.status && { status: this.status }),
					...(this.search && { search: `%${this.search}%` }),
					...(this.contractCategory && { contractCategory: this.contractCategory }),
				})

				this.$axios({
					url: `${process.env.VUE_APP_API_URL}/contracts/export?${params}`,
					method: 'GET',
					responseType: 'blob',
				}).then(response => {
					const fileURL = window.URL.createObjectURL(new Blob([response.data]))
					const fileLink = document.createElement('a')

					fileLink.href = fileURL
					fileLink.setAttribute('download', 'CONTRATOS.xlsx')
					document.body.appendChild(fileLink)

					fileLink.click()
					this.downloading = false
				})
			}
		},
	},
}
</script>
